import { MerchantPortalService } from './model/squareup/buyerportal/merchantportal/service';
import rpc from './rpc';

const merchantPortalClient = MerchantPortalService.create(rpc());

export default merchantPortalClient;
